/* ----- layout defs ----- */
export const LAYOUT_DEFS = {
  SINGLE: 'single',
  TABLE: 'table',
  LIST: 'list',
  SLIDER: 'slider'
}

export const ERROR_DEFS = {
  CONFIG: 'Error in component configuration!',
  SERVER_API: 'Error calling the server API!',
}

/* ----- functional defs ----- */
export const PIT_DEFS = { pitStripe: 'pit-stripe', pitPaypal: 'pit-paypal' }

export const CONTENT_TYPE_DEFS = {
  COMM_PRODUCT: 'ct-commProduct',
  EVENT: 'ct-event'
}

export const PUSH_HISTORY_STATE_DEFS = {
  QUERY_PARAM: 'query-param',
  URI: 'uri'
}
